"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouriteInvalidStudyId = void 0;
const wishlist_exception_1 = require("./wishlist-exception");
class FavouriteInvalidStudyId extends wishlist_exception_1.WishlistException {
    constructor(studyId) {
        super(`Invalid study id, expected to be of type number: ${JSON.stringify(studyId)}`);
        this.studyId = studyId;
        this.name = 'FavouriteInvalidStudyId';
    }
}
exports.FavouriteInvalidStudyId = FavouriteInvalidStudyId;
